import { render, staticRenderFns } from "./InfoChart2.vue?vue&type=template&id=f2823b66&scoped=true"
import script from "./InfoChart2.vue?vue&type=script&lang=js"
export * from "./InfoChart2.vue?vue&type=script&lang=js"
import style0 from "./InfoChart2.vue?vue&type=style&index=0&id=f2823b66&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2823b66",
  null
  
)

export default component.exports